module.exports = __webpack_public_path__ + "img/Frame 427322911.8e97d023.png";